import { NeoModel } from "@singularsystems/neo-core";
import BaseCheckQueryConfigCommand from "./BaseCheckQueryConfigCommand";

@NeoModel
export default class UpdateServiceProviderHouseCheckQuery extends BaseCheckQueryConfigCommand {
    public staticServiceProviderHouseCheckQueryId: number = 0;
}